
import { Dispatch, SetStateAction, useEffect } from 'react';
import { KaziModal } from '../../../../../../Shared Components/Kazi/KaziModal';
import { EducationFields } from '../../../../../../Shared Components/EducationFields';
import { useForm } from 'react-hook-form';
import { EducationSchema, EducationType, ExperienceSchema, ExperienceType } from '../../../../../../Schemas/ResumeSchemas';
import { yupResolver } from '@hookform/resolvers/yup';
import { KaziButton } from '../../../../../../Shared Components/Kazi/KaziButton';
import { ExperienceFields } from '../../../../../../Shared Components/ExperienceFields';

interface ModifyExperienceModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    handleChange: (data: ExperienceType) => void;
    type: string;
    defaultValues?: ExperienceType;
}
export const ModifyExperienceModal = ({open, setOpen, handleChange, defaultValues, type}:ModifyExperienceModalProps ) => {
    /* ******************** Hooks ******************** */
    const {
        control,
        handleSubmit,
        watch,
        reset
    } = useForm<ExperienceType>({
        defaultValues,
        resolver: yupResolver(ExperienceSchema)
    })
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false);
        reset();
    }
    /* ******************** Effects ******************** */
    useEffect(() => {
        reset();
    }, [])
    /* ******************** JSX ******************** */
    return (
        <KaziModal
            open={open}
            handleClose={handleClose}
            title={`${type} Experience`}
            content={<><ExperienceFields {...{control}} presentChecked={watch('present')} /></>}
            actions={[
                <KaziButton 
                    variant='contained'
                    text='Save'
                    onClick={handleSubmit(handleChange)}
                />
            ]}
        />
    )
}